import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';

import { cleanViewConfigResponse, findSubscription, findSubscriptionBySubNumebr, next, updateGlobalObject, verifyOTP, verifyOTPCode, verifySpecific } from 'app/modules/account/service';
import { ACTION_TYPES } from 'app/modules/account/service/store/actions';
import { selectContract, subList } from 'app/modules/account/service/store/selectors';
import { ViewName } from 'app/modules/account/ui/tools/constants';
import { getDocCMS } from 'app/modules/cms/service/cmsService';
import { getAccoutAssignementSelector } from 'app/modules/cms/service/store/selectors';
import { RulesKeys } from 'app/modules/rules/domain/rules.keys';
import { RulesContext } from 'app/modules/rules/domain/RulesContext';
import { View } from 'app/modules/rules/domain/View';
import { getDataView } from 'app/modules/rules/service/rulesService';
import { getDataViewRules } from 'app/modules/rules/service/store/selectors';
import { getAccountEmail } from 'app/modules/user/service/store/selectors';
import ConfComp from 'app/shared/components/common/conf-component';
import ContractPageSkeleton from 'app/shared/components/skeleton/desktop/s-contract-page';
import Loader from 'app/shared/components/spb/loader/loader';
import { IRootState } from 'app/shared/reducers';
import { isMobileDevice } from 'app/shared/util/methode-util';
import './style.scss';



const AccountAssignementEngine = () => {
  const configuration: any = useSelector<IRootState>(state => state.global.configuration);
  const filterDataList = (componentDataList: any, componentDataKey: string) => {
    return componentDataList?.find(e => e.componentDataKey === componentDataKey);
  };

  const email = useSelector(getAccountEmail);
  const dispatchor = useDispatch();
  const viewDataitems = useSelector(getDataViewRules(View.ACCOUNT_ENGINE));
  const subscriptionList: any = useSelector<IRootState>(subList);
  const selectedContract: any = useSelector<IRootState>(selectContract);
  const loadingData: any = useSelector<IRootState>(state => state.account.loadingData);
  const loadingView: any = useSelector<IRootState>(state => state.account.loadingView);
  const loadingVerif: any = useSelector<IRootState>(state => state.account.loadingVerif);
  const loadingSmsMail: any = useSelector<IRootState>(state => state.account.loadingSmsMail);
  const loadingCheckMail: any = useSelector<IRootState>(state => state.account.loadingCheckMail);
  const avatar: any = useSelector<IRootState>(state => state.global.avatar);
  const product: any = useSelector<IRootState>(state => state.global.configuration.productCode);
  const viewConfigResponse: any = useSelector<IRootState>(state => state.account.viewConfigResponse);
  const NumberVerfied: any = useSelector<IRootState>(state => state.account.NumberVerfied);

  const [globalObjectState, setGlobalObjectState] = useState(useSelector<IRootState>(state => state.account.globalObject) as any);
  const [isSearch, setIsSearch] = useState(false);
  const [arrayOfAdhesion, setArrayOfAdhesion] = useState([]);
  const history = useHistory();

  const rulesContext: RulesContext = {
    key: RulesKeys.GET_VIEW_DATA_CONFIGURATION,
    entryDataRules: { view: View.ACCOUNT_ENGINE, productCode: product },
  };

  const verifList = (sList) => {
    if (globalObjectState?.currentView === "") {
      globalObjectState.subscriptionsNotAttachement = sList;
      globalObjectState.currentView = ViewName.EFFECTIVE_VIEW;

      dispatchor(next(globalObjectState));
    }
  }
  const accoutAssignementCms: any = useSelector(getAccoutAssignementSelector);

  useEffect(() => {
    dispatchor(getDataView(rulesContext));
    dispatchor(findSubscription(verifList));
    dispatchor(getDocCMS('mobile_account_assignement_v2'));
  }, []);

  const updateObject = (viewName, viewObject, attributParam) => {
    dispatchor(updateGlobalObject(viewName, viewObject, attributParam));
  }
  useEffect(() => {
    if (viewConfigResponse?.nextView === ViewName.HOME) {
      dispatchor(cleanViewConfigResponse())
      history.push('/');
      dispatchor({ type: ACTION_TYPES.RESET_STATE });
    }
    if (viewConfigResponse !== null) {
      globalObjectState.currentView = viewConfigResponse?.nextView;
    }


    if (viewConfigResponse?.nextView === ViewName.VERIF_SUBSCRIPTION_PROCESS) {
      updateObject(ViewName.VERIF_SUBSCRIPTION_PROCESS, {
        ...globalObjectState?.viewPayload.get(ViewName.VERIF_SUBSCRIPTION_PROCESS),
        notCriteriaForVerifed: false, maxVerifTry: false, moreSubscription: false
      }, 'array');
    }
  }, [viewConfigResponse]);

  const nextView = () => {
    dispatchor(next(globalObjectState));
  };


  const searchContractByNumber = subscriptionNumber => {
    dispatchor(findSubscriptionBySubNumebr(subscriptionNumber));
  };

  const verifyContract = (subscriptionNumber, mode) => {
    dispatchor(verifyOTP(subscriptionNumber, mode));
  };

  const verifyContractOTP = (subscriptionNumber, value, mode) => {
    dispatchor(verifyOTPCode(subscriptionNumber, value, mode));
  };


  const verifySpecify = (subscriptionNumber, value, mode) => {
    dispatchor(verifySpecific(subscriptionNumber, value, mode));
  }

  const handleMaxTry = () => {
    dispatchor(updateGlobalObject(ViewName.SUBSCRIPTION_ACCOUNT_SEARCH, { maxTry: true }, 'array'));
    nextView();
  }

  const verifTryMax = (subNumber) => {
    arrayOfAdhesion.push(subNumber);

    const result = arrayOfAdhesion.filter(sub => sub === subNumber);
    if (result.length === 3) {
      handleMaxTry();
    }
  };

  return loadingView || loadingData ? (
    <>
      {isMobileDevice(configuration) ?
        <Loader />
        :
        <ContractPageSkeleton />
      }
    </>
  ) : (
    <>
      {viewConfigResponse?.nextView === ViewName.EMAIL_ACCOUNT_ATTACHEMENT && (
        <ConfComp
          code={ViewName.EMAIL_ACCOUNT_ATTACHEMENT}
          listCode={viewDataitems?.componentDataList}
          props={{ globalObjectState, nextView, subscriptionList, setGlobalObjectState, updateObject, accoutAssignementCms }}
        />
      )}

      {viewConfigResponse?.nextView === ViewName.SUBSCRIPTION_ACCOUNT_SEARCH && (
        <ConfComp
          code={ViewName.SUBSCRIPTION_ACCOUNT_SEARCH}
          listCode={viewDataitems?.componentDataList}
          props={{
            globalObjectState,
            nextView,
            searchContractByNumber,
            setGlobalObjectState,
            selectedContract,
            avatar,
            isSearch,
            setIsSearch,
            verifTryMax,
            handleMaxTry,
            updateObject,
            loadingCheckMail,
            accoutAssignementCms
          }}
        />
      )}

      {viewConfigResponse?.nextView === ViewName.MOBILE_NO_MATCHED_CONTACT && (
        <ConfComp
          code={ViewName.MOBILE_NO_MATCHED_CONTACT}
          listCode={viewDataitems?.componentDataList}
          props={{ globalObjectState, nextView, setGlobalObjectState, updateObject, accoutAssignementCms }}
        />
      )}
      {viewConfigResponse?.nextView === ViewName.VERIF_SUBSCRIPTION_PROCESS && (
        <ConfComp
          code={ViewName.VERIF_SUBSCRIPTION_PROCESS}
          listCode={viewDataitems?.componentDataList}
          props={{ globalObjectState, nextView, selectedContract, avatar, verifySpecify, verifyContract, verifyContractOTP, NumberVerfied, loadingVerif, loadingSmsMail, updateObject, accoutAssignementCms }}
        />
      )}

      {viewConfigResponse?.nextView === ViewName.CONTACT_GESTIONNAIRE && (
        <ConfComp
          code={ViewName.CONTACT_GESTIONNAIRE}
          listCode={viewDataitems?.componentDataList}
          props={{ globalObjectState, nextView, setGlobalObjectState, selectedContract, updateObject, accoutAssignementCms }}
        />
      )}
    </>
  );
};

export default React.memo(AccountAssignementEngine);
